import React, { useState } from "react";

import noImage1 from "../../assets/images/noimage1.png";
// import LoadingGif from "../assets/images/loading_gray.gif";

const LazyImage = ({ src, noImage = noImage1 , width , height , style , ...props }) => {
  const [loading, setLoading] = useState(true);

  return (
<div style={{ position: "relative", width , height  }}>
      {/* Loader */}
      {loading && (
        <>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f0f0f0",
            borderRadius: 5,
          }}
        >
          {/* <span>Loading...</span> */}
        </div>
            {/* <div className="d-flex justify-content-center align-items-center">
        <div class="spinner"></div>
            </div> */}
        </>
      )}

      {/* Image */}
      <img
        className="img-fluid"
        style={{
          height,
          width,
          boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
          border: "0.5px solid rgba(255, 255, 255, 0.20)",
          borderRadius: 5,
          objectFit: "cover",
          ...style
        }}
        src={src || noImage}
        onLoad={() => setLoading(false)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
          setLoading(false);
        }}
        alt=""
        {...props}
      />
    </div>
  );
};

export default LazyImage;
